import LegalPage from "../../components/LegalPage/LegalPage";

const sections = [
  {
    heading: "Using Our Services",
    paragraphs: [
      "By using Chill Tree you agree to use the site, checkout, subscriptions, and account tools only for lawful personal use.",
      "You are responsible for making sure the information you provide during checkout, account creation, and support requests is accurate and current.",
    ],
  },
  {
    heading: "Orders And Payments",
    paragraphs: [
      "Orders are subject to availability, payment approval, and age-gating requirements where applicable.",
      "Prices, promotions, and shipping timelines may change without notice, but confirmed orders will honor the pricing shown at checkout.",
    ],
  },
  {
    heading: "Subscriptions",
    paragraphs: [
      "Subscription purchases renew according to the billing cadence selected at checkout until they are paused or cancelled.",
    ],
    items: [
      "You can manage or cancel eligible subscriptions from your account or by contacting support.",
      "Failed payments may delay shipments or pause the renewal cycle until billing is updated.",
    ],
  },
  {
    heading: "Content And Intellectual Property",
    paragraphs: [
      "All site content, branding, product imagery, copy, and design elements remain the property of Chill Tree or its licensors.",
      "You may not copy, redistribute, or commercially reuse site materials without written permission.",
    ],
  },
];

export default function TermsOfService() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Terms of Service"
      intro="These terms explain how you may use the Chill Tree website, checkout experience, subscriptions, and account features."
      lastUpdated="April 14, 2026"
      sections={sections}
    />
  );
}




